import React, { FC } from "react";
import { CostTable, CostTableProps, TotalAggregationView, TableContainer } from "../CostTable/CostTable";
import { ThemeProps } from "common/components/ui/shared/theme";
import styled from "@emotion/styled";
import { LoadingSpinner } from "../LoadingSpinner";

export interface MultiTableCostDataProps {
  costTables: CostTableProps[];
  totalAggregation?: number | string;
  aggregationDescription?: JSX.Element | string;
  totalCostLabel?: JSX.Element | string;
  isLoading?: boolean;
}

const GroupTotalContainer = styled.div<ThemeProps>(
  ({ theme }) => `
    display: flex;
    justify-content: space-between;
    align-items: center;
  `
);

export const MultiTableCostData: FC<MultiTableCostDataProps> = ({
  costTables,
  totalAggregation,
  aggregationDescription,
  totalCostLabel,
  isLoading,
}) => {
  return (
    <>
      {isLoading && <LoadingSpinner center />}
      {totalAggregation && costTables.length > 1 && (
        <TableContainer hasDiscount={false} data-testid="cost-table" key={`costTable-costTableAggregatedView}`}>
          <GroupTotalContainer data-testid="cost-table" key={`costTable-costTableAggregatedView}`}>
            <TotalAggregationView
              totalAggregation={totalAggregation}
              totalCostLabel={totalCostLabel}
              aggregationDescription={aggregationDescription}
              hasAggregatedRow
            />
          </GroupTotalContainer>
        </TableContainer>
      )}
      {costTables.map((costTableProps, index) => (
        <CostTable key={`costTable-costTableSubGroup-${index}`} {...costTableProps} />
      ))}
    </>
  );
};
